<template>
  <section class="sec-2" ref="section2">
    <div class="sec-2__background"></div>
    <header class="sec-home-titr" ref="section2Titr">
      <h2 class="sec-home-titr__title"  :class="{'active':showSection2Title}">شگفتی های عسل</h2>
    </header>
    <main class="sec-2-main">
      <div class="marvels">
        <div class="marvels-item marvels-item-1" ref="section2Item1">
          <div class="marvels-item__image marvels-item-1__image">
            <div class="marvels-item__image__back"></div>
            <img src="../../public/image/work3.png" />
          </div>
          <div class="marvels-item__main marvels-item-1__main">
            <p class="marvels-item__parag">
              ضد میکروب است به گونه ای که اگر میکروبی در معرض اش قرارگیرد
              نابودمیشود زیرا عسل طبیعی حاوی آنتی‌بیوتیک و آنزیم دیاستاز است.
            </p>
          </div>
        </div>
        <div class="marvels-item marvels-item-2" ref="section2Item2">
          <div class="marvels-item__image marvels-item-2__image">
            <div class="marvels-item__image__back"></div>
            <img src="../../public/image/work2.png" />
          </div>
          <div class="marvels-item__main marvels-item-2__main">
            <p class="marvels-item__parag">
              با اینکه بسیار شیرین است،اما برای دندان ها و لثه مضر نیست،بلکه
              دندان هارا سفید میکند و لثه هارا سالم میسازد.
            </p>
          </div>
        </div>
        <div class="marvels-item marvels-item-3" ref="section2Item3">
          <div class="marvels-item__image marvels-item-3__image">
            <div class="marvels-item__image__back"></div>
            <img src="../../public/image/work1.png" />
          </div>
          <div class="marvels-item__main marvels-item-3__main">
            <p class="marvels-item__parag">
              حاوی آنتی اکسیدان است از این رو به سلامت پوست کمک میکند و ضد پیری
              است.
            </p>
          </div>
        </div>
        <div class="marvels-item marvels-item-4" ref="section2Item4">
          <div class="marvels-item__image marvels-item-4__image">
            <div class="marvels-item__image__back"></div>
            <img src="../../public/image/work3.png" />
          </div>
          <div class="marvels-item__main marvels-item-4__main">
            <p class="marvels-item__parag">
              خاصیت بهبود بخشی داروها را چند برابر میکند،از این رو در بسیاری از
              محصولات آرایشی و بهداشتی استفاده میشود.
            </p>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  data(){
    return{
      showSection2Title:false,
    }
  },
  mounted(){
    // let section2 = this.$refs.section2
    let titr = this.$refs.section2Titr
    let item1 = this.$refs.section2Item1
    let item2 = this.$refs.section2Item2
    let item3 = this.$refs.section2Item3
    let item4 = this.$refs.section2Item4
    let itemArray=[item1,item2,item3,item4]
    let vh=window.innerHeight * 4 / 5

     itemArray.forEach(item => {

       window.addEventListener("scroll", () => {
         let topOfItem=item.getBoundingClientRect().top
      // let topOfsection2=section2.getBoundingClientRect().top
      let topOfTitr=titr.getBoundingClientRect().top
         if(topOfTitr<vh){
          this.showSection2Title=true
         }
         if(topOfItem<vh){
           item.classList.add('active')
         }
       });
     });
  }
};
</script>

<style></style>
